<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="550" persistent>
    <v-card rounded="xl">
      <v-card-title class="text-h6 font-weight-bold pt-5 px-6">
        Complemento de Pago
      </v-card-title>
      <v-card-text class="px-6">
        <p class="body-2 mb-4">
          Registra un complemento de pago para la factura PPD de esta orden.
        </p>
        <v-form ref="form" v-model="formValid">
          <v-text-field
            v-model.number="amount"
            label="Monto del pago *"
            type="number"
            prefix="$"
            filled rounded dense
            :rules="[v => !!v && v > 0 || 'El monto debe ser mayor a 0']"
          />
          <v-select
            v-model="paymentForm"
            :items="paymentForms"
            label="Forma de pago *"
            filled rounded dense
            :rules="[v => !!v || 'Requerido']"
          />
          <v-menu
            v-model="dateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="paymentDate"
                label="Fecha del pago"
                filled rounded dense readonly
                v-bind="attrs" v-on="on"
                prepend-inner-icon="mdi-calendar"
              />
            </template>
            <v-date-picker v-model="paymentDate" @input="dateMenu = false" no-title />
          </v-menu>
        </v-form>
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn text rounded color="grey darken-1" @click="close" :disabled="loading">
          Cancelar
        </v-btn>
        <v-btn
          :color="color.primary"
          rounded
          class="white--text font-weight-bold"
          @click="submit"
          :loading="loading"
          :disabled="!formValid"
        >
          Emitir Complemento
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Endpoints from "@/share/Endpoints";
import { colors } from "@/constants/colors.js";
import { mapMutations } from "vuex";

export default {
  props: {
    value: { type: Boolean, default: false },
    order: { type: Object, default: null },
  },
  data: () => ({
    color: colors,
    formValid: false,
    loading: false,
    dateMenu: false,
    amount: null,
    paymentForm: "03",
    paymentDate: new Date().toISOString().substring(0, 10),
    paymentForms: [
      { text: "Efectivo (01)", value: "01" },
      { text: "Transferencia bancaria (03)", value: "03" },
      { text: "Tarjeta de crédito (04)", value: "04" },
      { text: "Tarjeta de débito (28)", value: "28" },
    ],
  }),
  watch: {
    value(open) {
      if (open) {
        this.amount = null;
        this.paymentForm = "03";
        this.paymentDate = new Date().toISOString().substring(0, 10);
      }
    },
  },
  methods: {
    ...mapMutations("notification", ["show"]),
    close() {
      this.$emit("input", false);
    },
    async submit() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      try {
        const url = Endpoints.invoicesOrderComplement.replace(/:orderId/, this.order.id);
        const { data } = await this.axios.post(url, {
          amount: this.amount,
          paymentForm: this.paymentForm,
          paymentDate: this.paymentDate,
        });
        this.show({ text: data.message || "Complemento emitido exitosamente", color: "success", time: 3000 });
        this.$emit("complemented");
        this.close();
      } catch (error) {
        const msg = error.response?.data?.error?.message || "Error al crear el complemento de pago";
        this.show({ text: msg, color: "error", time: 4000 });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
